import React from 'react'
import { momentumService } from '../../../_services'
import { toast } from 'react-toastify'
import { CheckIcon, ErrorIcon } from '../../../_components'

export const momentumUpdate = async (momentum, status, removeMomentumFromArray) => {
  const json = JSON.parse(momentum)
  const oldStatus = json.status
  json.status = status

  const res = await momentumService.updateMomentumStatus(JSON.stringify(json))
  
  if ( !res )
    return toastMessage("error", "Ocorreu um erro ao executar sua solicitação. <strong>Tente novamente mais tarde.</strong>")
  
  if ( res.status !== 200 )
    return toastMessage("error", "Ocorreu um erro ao <strong>atualizar o status do seu momentum.</strong>. Tente novamente mais tarde.")
  
  let message = ""
  const statusToText = {
    "Active": () => { message = "iniciado" },
    "Paused": () => { message = "pausado" },
    "Deleted": () => { message = "removido" }
  }
  statusToText[status]()

  toastMessage("success", `Seu momentum foi <strong>${message}.</strong>`)
  removeMomentumFromArray(oldStatus, json)
}

const toastMessage = (type, message) => {
  toast.success(
    <div>
      {
        type === "success" ?
          <CheckIcon />
        : <ErrorIcon />
      }
      <span dangerouslySetInnerHTML={{__html: message}}></span>
    </div>
  , {
    className: `toast__success toast__success--white`
  })
}